import React from "react";
import { connect } from "react-redux";
import mixpanel from "../../services/mixpanel";
import CollectionsList from "./components/CollectionsList";
import CollectionCard from "./components/CollectionCard";
import { openNewCollectionFormModal } from "../../actions/collectionActions";
import CreateCollectionButton from "./components/CreateCollectionButton";
import { collectionFormModalTriggerSources } from "../../constants";
import "./index.css";

const CollectionsPage = ({ isOwnProfile, collections, loadMoreCollections, actions }) => {
  const openNewCollectionModal = () => {
    actions.openNewCollectionFormModal();
    mixpanel.track("addNewCollection");
  };
  return (
    <div className="collections-page">
      <div className="header">
        <h2 className="title">Collections</h2>
        {isOwnProfile ? <CreateCollectionButton onClick={openNewCollectionModal} /> : null}
      </div>
      <div className="list">
        <CollectionsList
          collections={collections}
          loadMoreCollections={loadMoreCollections}
          collectionComponent={CollectionCard}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  actions: {
    openNewCollectionFormModal: () =>
      dispatch(openNewCollectionFormModal(collectionFormModalTriggerSources.COLLECTIONS_PAGE)),
  },
});

export default connect(null, mapDispatchToProps)(CollectionsPage);



// WEBPACK FOOTER //
// ./src/scenes/CollectionsPage/index.js